module.exports = __webpack_public_path__ + "static/img/application6-5.619b9b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application6-5.jpg
// module id = NXHu
// module chunks = 0